<template>
    <div>
        User Create
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>